import {readShopifyFeatures} from 'utilities/shopify-features';

const KEY_SHOPS = [
  6377406519, 40009040038, 61664067822, 14483500, 56030625949, 5822885,
];

export function isKeyShop() {
  const {shopId} = readShopifyFeatures();

  return shopId !== undefined && KEY_SHOPS.includes(shopId);
}
